let iframe = null;

export function sendMsg(msg) {
  if (!iframe) {
    iframe = new Promise((resolve, reject) => {
      const el = document.createElement('iframe');
      el.style.width = el.style.height = el.style.opacity = el.style.border = 0;
      el.style.position = 'absolute';
      el.onload = () => resolve(el);
      el.onerror = () => {
        iframe = null;
        reject(el);
      };
      el.src = `${process.env.VUE_APP_HOME_URL}/pagebus.html`;
      document.body.appendChild(el);
    });
  }

  iframe.then((el) => {
    el.contentWindow.postMessage(JSON.stringify(msg), '*');
  });
}

export default {
  sendMsg
};